import React, { useEffect } from "react";
import { useRouter } from "next/router";
import AuthPage from "../../components/AuthPage";
import { LoadingPage } from "../../components/common";
import { useAuth } from "@/services/hooks/useAuth";

const NewMemberSignUpPage = (props) => {
    const { isLoading, user, isVoyager, registerWithEmailAndPassword } = useAuth();
    const router = useRouter();

    useEffect(() => {
        if (user && user !== null) {
            if (!isVoyager) {
                router.push("/onboarding?join=true");
            } else {
                router.push("/onboarding");
            }
        }
    }, [user]);

    if (isLoading || user !== null) {
        return <LoadingPage />;
    }

    if (user === null) {
        return (
            <AuthPage
                labels={{
                    NAME: "Join the Vacayou Voyager Club",
                    SUBMIT_BUTTON_TEXT: "Sign up",
                    REDIRECT_PROMPT: `Already have a Vacayou Voyager Club account?`,
                    REDIRECT_PROMPT_LINK_TEXT: "Log in",
                    REDIRECT_PROMPT_LINK_URL: "/login",
                    NEXT_PAGE: "/onboarding?join=true",
                    WRITEUP: true,
                    WRITEUP_TEXT:
                        "Get access to exclusive getaways and retreats, member-only booking benefits, exclusive content, membership perks, a dedicated travel concierge and much more!",
                    CTA: true,
                    CTA_TEXT: "Join Now!",
                    DISPLAY_FORGOT_PASSWORD: false,
                }}
                onSubmit={registerWithEmailAndPassword}
            />
        );
    }
};

export default NewMemberSignUpPage;
